export default __webpack_public_path__ + "static/media/kwid-colour-4.ac40bf95.jpg";